import React, { useState, useEffect } from "react";
import {
  Avatar,
  Avatargroup,
  Box,
  Button,
  Dropdown,
  DropdownItem,
  getColor,
  Icons,
  Tabs,
  Tag,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import classNames from "classnames";
import "./index.scss";
import { Member, Workgroup, WorkgroupDetailDTO } from "../../types/workgroup";
import useWorkgroupStore from "../../redux/dispatcher/useWorkgroupStore";
import utilsCommon from "../../shared/utils/common";
import WorkgroupManagerIcon from "../WorkgroupManagerIcon";
import RevisionTag from "../RevisionTag";
import { useTranslation } from "react-i18next";
interface WorkgroupAsideProps {
  classes?: string;
  workgroupId: string;
}

const WorkgroupAside: React.FC<WorkgroupAsideProps> = ({
  workgroupId,
  classes,
}) => {
  const { t } = useTranslation();
  const { workgroupState, getWorkgroupDetail } = useWorkgroupStore();
  const [workgroupDetail, changeWorkgroupDetail] = useState<
    WorkgroupDetailDTO | undefined
  >();
  useEffect(() => {
    if (workgroupId === workgroupState.workgroupDetail.workgroup.workgroupId) {
      changeWorkgroupDetail(workgroupState.workgroupDetail);
    } else {
      getWorkgroupDetail({ workgroupId });
    }
  }, [workgroupState.workgroupDetail]);

  const renderNameTag = (user?: Member, isManager?: boolean) => {
    return (
      <Box maxWidth={"100%"} minHeight={54} height={54} alignItems="center">
        <Avatar
          name={user?.userName ?? user?.userId}
          uniqueCode={utilsCommon.getUserColor(user?.userType, user?.status, user?.userName)}
          icon={user?.userName ? undefined : "user"}
        />
        <Box
          direction="column"
          justifyContent="center"
          classes="mg ml-8"
          width={isManager ? "calc(100% - 110px)" : "calc(100% - 62px)"}
        >
          <Tooltip
            message={utilsCommon.getUserNameIdTag(
              user?.userId ?? "",
              user?.userName
            )}
          >
            <Typography type="body2_rg" ellipsis>
              {utilsCommon.getUserNameIdTag(user?.userId ?? "", user?.userName)}
            </Typography>
          </Tooltip>
          <Tooltip
            message={utilsCommon.getUserPositionNDept({
              positionName: user?.positionName,
              deptName: user?.deptName,
              companyName: user?.companyName,
              userType: user?.userType,
            })}
          >
            <Typography
              classes="mg mt-2"
              type="caption1_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
              ellipsis
            >
              {utilsCommon.getUserPositionNDept({
                positionName: user?.positionName,
                deptName: user?.deptName,
                companyName: user?.companyName,
                userType: user?.userType,
              })}
            </Typography>
          </Tooltip>
        </Box>
        {isManager && (
          <Tag
            fontSize={12}
            backgroundColor={getColor("COLOR_AVATAR_GREEN_BG")}
            text={t("home.myTasks.head")}
            textColor={getColor("COLOR_TEXT_BRAND")}
            classes="mg ml-auto"
          />
        )}
      </Box>
    );
  };
  const renderMemberTab = () => {
    const managerId = workgroupState.workgroupDetail?.workgroup?.managerId;
    return (
      <Box direction="column" classes="mg mt-8">
        {renderNameTag(
          workgroupState.workgroupDetail?.workgroup?.members.filter(
            (item: Member) => managerId === item?.userId
          )[0],
          true
        )}
        {workgroupState.workgroupDetail?.workgroup?.members
          .filter(
            (item: Member) => managerId !== item?.userId && item.userType === 1
          )
          .map((user: Member) => renderNameTag(user))}
        {workgroupState.workgroupDetail?.workgroup?.members
          .filter(
            (item: Member) => managerId !== item?.userId && item.userType === 2
          )
          .map((user: Member) => renderNameTag(user))}
      </Box>
    );
  };
  return workgroupDetail ? (
    <Box classes="workgroupAside">
      <Box
        classes="workgroupAside-graybox"
        alignItems="center"
        justifyContent="center"
      >
        <Avatar
          shape="workgroup"
          uniqueCode={workgroupDetail.workgroup.workgroupId}
          name={workgroupDetail.workgroup.workgroupName}
          size="48"
        />
        <Tooltip message={workgroupDetail.workgroup.workgroupName}>
          <Typography classes="mg mt-8" type="subtitle1" ellipsis>
            {workgroupDetail.workgroup.workgroupName}
          </Typography>
        </Tooltip>
        <Tooltip message={workgroupDetail.workgroup.desc}>
          <Typography
            type="body4_rg"
            ellipsis
            classes="mg mt-4"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {workgroupDetail.workgroup.desc}
          </Typography>
        </Tooltip>
      </Box>
      <Box direction="column" classes="mg mt-24">
        <Typography type="subtitle2">{t("file.lastUpdate")}</Typography>
        <Typography type="body2_rg">
          {utilsCommon.renderDateFormat(
            workgroupDetail.workgroup?.updateDate ?? 0
          )}
        </Typography>
      </Box>
      <Box direction="column" classes="mg mt-24">
        <Typography type="subtitle2">{t("common.createTime")}</Typography>
        <Typography type="body2_rg">
          {utilsCommon.renderDateFormat(
            workgroupDetail.workgroup?.logDate ?? 0
          )}
        </Typography>
      </Box>
      <Box direction="column" classes="mg mt-24">
        <Typography type="subtitle2">{t("common.member")}</Typography>
        {renderMemberTab()}
      </Box>
    </Box>
  ) : (
    <></>
  );
};
export default WorkgroupAside;
